import { ActionContext } from "vuex";
import * as mt from "./mutation-types";
import { NotificationState, Notification } from "./types";
import { RootState } from "../types";

export default {
  [mt.ADD_NOTIFICATION](
    { commit }: ActionContext<NotificationState, RootState>,
    notification: Notification
  ) {
    commit(mt.ADD_NOTIFICATION, { notification });
  },

  [mt.CLEAR_NOTIFICATION](
    { commit }: ActionContext<NotificationState, RootState>,
    notification: Notification
  ) {
    commit(mt.CLEAR_NOTIFICATION, { notification });
  }
};
